import { AvatarSize } from 'antd/es/avatar/SizeContext';
import React, { FC } from 'react';
import styled from 'styled-components';
import { MemberType, Team } from 'api/models';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { UserTag } from 'components/atoms/select';
import { PlaceholderAvatar } from '../placeholder-avatar';
import { Option } from './types';

interface TriggerProps {
  value: Option[];
  size?: AvatarSize;
  isMini?: boolean;
}

const StyledUserTag = styled(UserTag)`
  min-width: 1px;
  max-width: 120px;
`;

const getAvatarImageProps = (option: Option) => {
  if (option?.extra?.type === 'team') {
    return {
      icon: (
        <PlaceholderAvatar
          name={option.label}
          isCustomerRole={
            option?.teamType === MemberType.External ||
            (option?.extra as unknown as Team)?.teamType === MemberType.External
          }
        />
      ),
    };
  }

  return {
    name: option?.label,
    src: option?.imageUrl,
    userStatus: option?.userStatus,
  };
};

export const Trigger: FC<TriggerProps> = ({
  value = [],
  size = 'default',
  isMini = false,
}) => {
  return value.length === 1 && !isMini ? (
    <StyledUserTag {...value[0]} {...getAvatarImageProps(value[0])} />
  ) : (
    <AvatarGroup maxCount={2} size={size}>
      {value.map((v) => (
        <Avatar
          key={v.label}
          size={size}
          companyLogoUrl={v.logoUrl}
          {...getAvatarImageProps(v)}
        />
      ))}
    </AvatarGroup>
  );
};

export const AssigneeTrigger = Trigger;
